var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ledger-page"},[_c('ledger',{attrs:{"assets-id":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }